import { render, staticRenderFns } from "./AddNewImage.vue?vue&type=template&id=a9a1ca46"
import script from "./AddNewImage.vue?vue&type=script&lang=js"
export * from "./AddNewImage.vue?vue&type=script&lang=js"
import style0 from "./AddNewImage.vue?vue&type=style&index=0&id=a9a1ca46&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports